import { render, staticRenderFns } from "./Dispositions.vue?vue&type=template&id=35c21c39&"
import script from "./Dispositions.vue?vue&type=script&lang=js&"
export * from "./Dispositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports